import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderExporter  {
    _originalTypeClassName = "zERP.BO.PaymentOrderExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderExporter.translate = translateService;
}
this.PaymentOrderExporterKey = null;
this._key = this.PaymentOrderExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PaymentOrderExporterKey:any;
get PaymentOrderExporterKey(): any {
    return this._PaymentOrderExporterKey;
  }
set PaymentOrderExporterKey(value: any) {
    this._PaymentOrderExporterKey = value;
    this._key = value;
  }

static CalculateBottomLineInfo(iban: any,date: any,checkNumber: any,amount: any): any{let dateStr = CLMS.Framework.DateTime.ToString(date, "ddMMyy");
let checkNumberStr = Joove.Common.replaceAll(checkNumber, "-", "");
let amountStr = numeral((Joove.Common.safeNumber(amount) * Joove.Common.safeNumber(100))).format("N");
return CLMS.Framework.String.Format("1<{0}>    {1}<{2}+    >{3}>", iban, dateStr, checkNumberStr, amountStr);
}
static GetCollectionVariables(paymentOrder: any): any{let vars = new window['Map']();
let invoicesChildren = [];
invoicesChildren?.add({
Name: "number_date",Description: "Σειρά/Ημερομηνία",}
);
invoicesChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
invoicesChildren?.add({
Name: "net_amount",Description: "Καθαρό ποσό",}
);
invoicesChildren?.add({
Name: "vat_amount",Description: "Ποσό ΦΠΑ",}
);
invoicesChildren?.add({
Name: "gross_amount",Description: "Μικτό ποσό",}
);
let taxesChildren = [];
taxesChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
taxesChildren?.add({
Name: "amount",Description: "Ποσό",}
);
vars.set({
Name: "INVOICES",Description: "Παραστατικά",IsCollection: true,Children: invoicesChildren,}
, Joove.Common.cast(paymentOrder?.Documents, "System.Collections.List"));
vars.set({
Name: "TAXES",Description: "Φόροι",IsCollection: true,Children: taxesChildren,}
, Joove.Common.cast(paymentOrder?.Documents?.linq?.select((d) => d?.Invoice)?.toArray()?.linq?.selectMany((i) => i?.TaxesTotals)?.toArray(), "System.Collections.List"));
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "INVOICES") {let paymentOrderInvoice = Joove.Common.cast(item, "Domain.PaymentOrderInvoice");let invoice = paymentOrderInvoice?.Invoice;switch (varName?.toLowerCase()) {case "number_date":
{
return invoice?.InvoiceHeader?.SeriesAndAA + " " + invoice?.InvoiceHeader?.IssueDate;}
case "description":
{
return "";}
case "net_amount":
{
return numeral(invoice?.InvoiceSummary?.TotalNetValue).format("N");}
case "vat_amount":
{
return numeral(invoice?.InvoiceSummary?.TotalVatAmount).format("N");}
case "gross_amount":
{
return numeral(invoice?.InvoiceSummary?.TotalGrossValue).format("N");}
}}else if (collectionName == "TAXES") {let taxTotalsType = Joove.Common.cast(item, "Domain.TaxTotalsType");switch (varName?.toLowerCase()) {case "description":
{
return taxTotalsType?.Tax?.Name;}
case "amount":
{
return numeral(taxTotalsType?.TaxAmount).format("N");}
}}
return collectionName + "." + varName;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaymentOrderExporterKey == null || $this.PaymentOrderExporterKey == 0;
            }


}